import { AnyAction } from "redux";
import { get, update } from "../../../user";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import { Adapter } from "../../../../shared/adapter";
import { ProfileAdapter } from "../../../../adapter/profile-adapter";

export const FETCH_DATA_PROFILE_REQUEST = 'FETCH_DATA_PROFILE_REQUEST';
export const FETCH_DATA_PROFILE_SUCCESS = 'FETCH_DATA_PROFILE_SUCCESS';
export const FETCH_DATA_PROFILE_FAILURE = 'FETCH_DATA_PROFILE_FAILURE';
export const SET_PROFILE = 'SET_PROFILE';
export const UPLOAD_IMAGE_PROFILE = 'UPLOAD_IMAGE_PROFILE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchDataRequest = () => {
    return {
        type: FETCH_DATA_PROFILE_REQUEST,
    };
};

const fetchDataSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_DATA_PROFILE_SUCCESS,
        payload: data
    };
};

const fetchDataFailure = (error: any) => {
    return {
        type: FETCH_DATA_PROFILE_FAILURE,
        payload: error,
    };
};

const setProfile = (data: any) => {
    return {
        type: SET_PROFILE,
        payload: data,
    };
}

export const updateProfile = (id: string, data: any) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchDataRequest());
        try {
            const response = await update('users', id, data);
            dispatch(fetchDataSuccess(
                Adapter.from(response.data).to((values) => new ProfileAdapter(values).adapt())
            ));
        } catch (error: any) {
            dispatch(fetchDataFailure(error.message));
        }
    };
};

export const getProfile = () => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchDataRequest());
        try {
            const response = await get();
            dispatch(setProfile(
                Adapter.from(response).to((values) => new ProfileAdapter(values).adapt())
            ));
        } catch (error: any) {
            dispatch(fetchDataFailure(error.message));
        }
    };
};
